import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-130">
      {isOpen && <div className="fixed inset-0 z-[60] flex items-center justify-center p-4" data-id="element-131">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-132" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl max-h-[80vh] glass-panel neon-box-green rounded-2xl overflow-hidden z-10" data-id="element-133">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-white/10" data-id="element-134">
              <h2 className="text-xl font-bold font-orbitron text-[#39FF14]" data-id="element-135">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-lg hover:bg-white/10 transition-colors text-gray-400 hover:text-white" data-id="element-136">
                <XIcon size={20} data-id="element-137" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-gray-300 text-sm leading-relaxed space-y-4 scrollbar-thin" data-id="element-138">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}